import { render, staticRenderFns } from "./openCode.vue?vue&type=template&id=7bdd10fb&scoped=true"
import script from "./openCode.vue?vue&type=script&lang=js"
export * from "./openCode.vue?vue&type=script&lang=js"
import style0 from "./openCode.vue?vue&type=style&index=0&id=7bdd10fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdd10fb",
  null
  
)

export default component.exports